/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {BaseFields, BaseModel, BaseProps, createFieldDef, FieldDefinition, ModelFieldType} from './baseModel';

import {ModelResponse} from '@dvrd/dvr-controls';

interface Props extends BaseProps {
    ean?: string;
    global_id?: string;
    title?: string;
    specs_tag?: string;
    subtitle?: string;
    short_description?: string;
    image_url?: string;
    product_url?: string;
}

interface Fields extends BaseFields {
    ean: string;
    global_id: string;
    title: string;
    specs_tag: string;
    subtitle: string;
    short_description: string;
    image_url: string;
    product_url: string;
}

const fields: Fields = {
    id: '',
    created_at: '',
    updated_at: '',
    ean: '',
    global_id: '',
    title: '',
    specs_tag: '',
    subtitle: '',
    short_description: '',
    image_url: '',
    product_url: ''
};

const fieldsDefinition: {[key in keyof Fields]: FieldDefinition} = {
    id: createFieldDef(ModelFieldType.STRING),
    created_at: createFieldDef(ModelFieldType.STRING),
    updated_at: createFieldDef(ModelFieldType.STRING, undefined, true),
    ean: createFieldDef(ModelFieldType.STRING),
    global_id: createFieldDef(ModelFieldType.STRING),
    title: createFieldDef(ModelFieldType.STRING),
    specs_tag: createFieldDef(ModelFieldType.STRING),
    subtitle: createFieldDef(ModelFieldType.STRING),
    short_description: createFieldDef(ModelFieldType.STRING),
    image_url: createFieldDef(ModelFieldType.STRING),
    product_url: createFieldDef(ModelFieldType.STRING)
};

const ignoreProps: Array<keyof Props> = [];

export default class BolOpenProduct extends BaseModel<Props, Fields> {
    static get = (_id: string, _callback: ModelResponse<BolOpenProduct>) => {};

    static getAll = (_callback: ModelResponse<BolOpenProduct[]>) => {};

    constructor(props?: Props) {
        super(ignoreProps, fieldsDefinition, fields, props);
        this.build(props);
    }

    get id(): string {
        return this.fields.id as string;
    }

    get ean(): string {
        return this.fields.ean;
    }

    set ean(ean: string) {
        this.fields.ean = ean;
    }

    get globalId(): string {
        return this.fields.global_id;
    }

    set globalId(global_id: string) {
        this.fields.global_id = global_id;
    }

    get title(): string {
        return this.fields.title;
    }

    set title(title: string) {
        this.fields.title = title;
    }

    get specsTag(): string {
        return this.fields.specs_tag;
    }

    set specsTag(specs_tag: string) {
        this.fields.specs_tag = specs_tag;
    }

    get subtitle(): string {
        return this.fields.subtitle;
    }

    set subtitle(subtitle: string) {
        this.fields.subtitle = subtitle;
    }

    get shortDescription(): string {
        return this.fields.short_description;
    }

    set shortDescription(short_description: string) {
        this.fields.short_description = short_description;
    }

    get imageUrl(): string {
        return this.fields.image_url;
    }

    set imageUrl(image_url: string) {
        this.fields.image_url = image_url;
    }

    get productUrl(): string {
        return this.fields.product_url;
    }

    set productUrl(product_url: string) {
        this.fields.product_url = product_url;
    }

    save = (_callback?: ModelResponse<BolOpenProduct>) => {};

    update = (_callback?: ModelResponse<BolOpenProduct>) => {};

    delete = (_callback?: ModelResponse<BolOpenProduct>) => {};

    protected build = (props?: Props) => {
        this.constructFields(props);
    };
}
